(() => {
    function loadCSS(url) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = url;
        document.head.appendChild(link);
    }

    function loadJS(url) {
        const script = document.createElement('script');
        script.src = url;
        script.defer = true;
        document.body.appendChild(script);
    }

    function loadAllLazyAssets() {
        if (window._lazyAssetsLoaded) return;
        window._lazyAssetsLoaded = true;

        (window.lazyCSS || []).forEach(loadCSS);
        (window.lazyJS || []).forEach(loadJS);
    }

    // Added 'wheel' for Windows scroll wheel and 'keydown' for Page Down / End key navigation
    ['click', 'scroll', 'wheel', 'mousemove', 'touchstart', 'keydown'].forEach(evt => {
        window.addEventListener(evt, loadAllLazyAssets, { once: true, passive: true });
    });

    // Fallback: load all lazy assets after 4 seconds regardless of interaction
    // Handles cases where events fire before window.lazyCSS/lazyJS are populated (race condition)
    setTimeout(loadAllLazyAssets, 4000);
})();